import { rootUrl } from '../const';
import { getExcelDown, getExcelEmptyFormDown } from './getExcelDown';

export const PosBoardAPI = {
	getExcelDown: getExcelDown(rootUrl),
	getExcelEmptyFormDown: getExcelEmptyFormDown(rootUrl),
};
